import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { Cart, updateCart, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { ORDER_SHIPPING_TYPE_ID_PROPERTY } from "@thkStore/Common/Constants/ShippingConstants";

type HandlerType = ApiHandlerDiscreteParameter<{ shippingTypeId: string }, UpdateCartApiParameter>;

export const DispatchSetShippingType: HandlerType = props => {
    props.dispatch({
        type: "Shipping/SetShippingType",
        shippingTypeId: props.parameter.shippingTypeId,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        // Avoid returning data if the shopping cart has not been loaded
        return false;
    }

    // Skip the API call when the cart already holds this value
    const target = ORDER_SHIPPING_TYPE_ID_PROPERTY.toLowerCase();
    const existingKey = cart.properties
        ? Object.keys(cart.properties).find(k => k.toLowerCase() === target)
        : undefined;
    const existingValue = existingKey ? cart.properties![existingKey] : undefined;
    if (existingValue && existingValue.toLowerCase() === props.parameter.shippingTypeId.toLowerCase()) {
        return false;
    }

    // Persist the chosen shipping type on the cart
    const updatedCart: Cart = {
        ...cart,
        properties: {
            ...(cart.properties || {}),
            [ORDER_SHIPPING_TYPE_ID_PROPERTY]: props.parameter.shippingTypeId,
        },
    };
    props.apiParameter = { cart: updatedCart };
};

export const UpdateCart: HandlerType = async props => {
    await updateCart(props.apiParameter);
};

export const LoadCart: HandlerType = props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    if (cartId) {
        props.dispatch(loadCart({ cartId, getPromotions: true }));
    } else {
        props.dispatch(loadCurrentCart({ getPromotions: true }));
    }
};

export const chain = [DispatchSetShippingType, PopulateApiParameter, UpdateCart, LoadCart];

const setShippingType = createHandlerChainRunner(chain, "SetShippingType");
export default setShippingType;
